import Vue from 'vue'
import App from './App.vue'
import router from './router'
//引入element




// import * as echarts from 'echarts/lib/echarts.js'
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
axios.defaults.baseURL = "http://113.45.153.159:8081"
//axios.defaults.baseURL = "http://113.45.153.159:8081"
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
